export default {
      id: "ic_trash_grey_back_match-usage",
      viewBox: "0 0 8 12",
      url: "/" + "images/icons.3.109.2.svg#ic_trash_grey_back_match-usage",
      toString: function () {
        return this.url;
      }
    }